var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18.0004C14 14.7695 16.6191 12.1504 19.85 12.1504H28.9934H29.3445L29.5933 12.3981L36.4498 19.2267L36.7 19.4759V19.829V23.0004C36.7 23.4698 36.3194 23.8504 35.85 23.8504C35.3806 23.8504 35 23.4698 35 23.0004V20.679H30.9934C29.4194 20.679 28.1434 19.403 28.1434 17.829V13.8504H19.85C17.558 13.8504 15.7 15.7084 15.7 18.0004V35.0004C15.7 37.2924 17.558 39.1504 19.85 39.1504H24.35C24.8194 39.1504 25.2 39.5309 25.2 40.0004C25.2 40.4698 24.8194 40.8504 24.35 40.8504H19.85C16.6191 40.8504 14 38.2313 14 35.0004V18.0004ZM29.8434 15.0466L33.792 18.979H30.9934C30.3583 18.979 29.8434 18.4641 29.8434 17.829V15.0466ZM19 24.0004C19 23.5309 19.3806 23.1504 19.85 23.1504H31.85C32.3194 23.1504 32.7 23.5309 32.7 24.0004C32.7 24.4698 32.3194 24.8504 31.85 24.8504H19.85C19.3806 24.8504 19 24.4698 19 24.0004ZM19 28.5289C19 28.0594 19.3806 27.6789 19.85 27.6789H28.65C29.1194 27.6789 29.5 28.0594 29.5 28.5289C29.5 28.9983 29.1194 29.3789 28.65 29.3789H19.85C19.3806 29.3789 19 28.9983 19 28.5289ZM19 33.0004C19 32.5309 19.3806 32.1504 19.85 32.1504H24.65C25.1194 32.1504 25.5 32.5309 25.5 33.0004C25.5 33.4698 25.1194 33.8504 24.65 33.8504H19.85C19.3806 33.8504 19 33.4698 19 33.0004ZM37.7245 27.1712C38.1761 26.6757 38.9541 26.6699 39.413 27.1587L39.9453 27.7258C40.3607 28.1683 40.3607 28.8574 39.9453 29.3L31.5939 38.1963C31.4277 38.3734 31.2097 38.4933 30.9712 38.5388L29.1512 38.8865C29.0466 38.9065 28.955 38.8141 28.976 38.7096L29.4121 36.5367C29.4532 36.3321 29.5491 36.1426 29.6896 35.9884L37.7245 27.1712ZM40.6524 25.9952C39.5152 24.7838 37.5871 24.7981 36.468 26.0261L28.4331 34.8433C28.0848 35.2255 27.8471 35.6952 27.7453 36.2022L27.3092 38.3751C27.0507 39.6632 28.1797 40.8028 29.4702 40.5563L31.2902 40.2086C31.8813 40.0957 32.4215 39.7986 32.8334 39.3599L41.1847 30.4635C42.2142 29.3668 42.2142 27.6589 41.1847 26.5623L40.6524 25.9952Z",
    fill: "url(#paint0_linear_4461_22634)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4461_22634",
    x1: 27.9784,
    y1: 12.1504,
    x2: 27.9784,
    y2: 40.8504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3C0E",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditData);
export default __webpack_public_path__ + "static/media/editData.8add6682406d93bcf60053c72e3f8650.svg";
export { ForwardRef as ReactComponent };